module.exports = "<taxihandgo-field placeholder=\"jjmmaaaa\" class=\"date\" (paste)=\"onPaste($event)\" [length]=\"8\" [(value)]=\"value\" #field>\n  <ng-content></ng-content>\n</taxihandgo-field>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/date/date.component.html
// module id = 492
// module chunks = 1